import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { environment } from '../environments/environment';

import { routes } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';

import { AppComponent } from './app.component';

import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { DashboardLayoutComponent } from './layout/dashboard-layout/dashboard-layout.component';

import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { ResponseInterceptor } from './core/interceptors/response-interceptor.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { HttpModule } from '@angular/http';
import { ReportHtmlComponent } from './modules/report/report-html/report-html.component';

@NgModule({
	declarations: [
		AppComponent,
		DashboardLayoutComponent,
		AuthLayoutComponent,
		ReportHtmlComponent
	],
	imports: [
		BrowserAnimationsModule,
		ToastrModule.forRoot(),
		HttpClientModule,
		RouterModule.forRoot(routes, {useHash: true}),
		SharedModule,
		CoreModule,
		HttpModule
		],
	providers: [
		{ provide: 'API_ENDPOINT', useValue: environment.API_ENDPOINT },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true
		}, {provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true}
	],
	bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/app.module.ts